<div class="card text-center mx-auto my-auto" style="width: 24rem;">
  <div class="card-body">
    <i-bs [name]="icon" [class]="iconColorClass" width="100" height="100"> </i-bs>
    <h5 class="card-title mt-4" [class]="messageTextColor">{{ message }}</h5>
  </div>
</div>
